import { Component, Vue, Prop } from 'vue-property-decorator';

import { Dictionary } from '../../types/Dictionary';
import { MenuItemDTO } from '../../model/MenuItemDTO';

@Component({
	name: 'wms-menu'	// necessary because of https://github.com/kaorun343/vue-property-decorator/issues/102
})
export class WmsMenu extends Vue {
	@Prop() menu: MenuItemDTO[];
	@Prop({ default: 0 }) parentId?: number;
	@Prop({ default: 0 }) level: number;
	@Prop({ default: false }) active: boolean;

	openedSubmenus: number[] = [];

	get classes() {
		const classes = [
			`mm-level-${this.level}`
		];

		if (this.level === 0) {
			classes.push('mm-menu');
			classes.push('main-menu');
		}

		if (this.active) {
			classes.push('active');
		}

		return classes;
	}

	get items(): any {
		if (!this.parentId) this.parentId = 0;
		var menuItems: MenuItemDTO[];

		menuItems = JSON.parse(JSON.stringify(this.menu)); //nutno přiřadit bez reference!

		const currentItems = menuItems
			.filter((item) => item.parentId === this.parentId)
			.sort((a, b) => a.order - b.order);

		currentItems.forEach(function (currentItem) {
			var hasChilds = menuItems.filter((item) => item.parentId === currentItem.id).length > 0;

			if (hasChilds && !(currentItem.label.indexOf("menu-child-icon") > 0)) {
				currentItem.label = currentItem.label + '<i class="fal fa-chevron-down menu-child-icon"></i>';
			}
		});

		return currentItems;
	}

	getItemStyle(item: MenuItemDTO) {
		const style: Dictionary<string> = {};

		if (item.decoration) {
			if (item.decoration.startsWith('#')) {
				style['background-color'] = item.decoration;
			} else {
				style['background-image'] = `url(${item.decoration})`;
			}
		}

		return style;
	}

	openSubmenu(item: MenuItemDTO, e: any) {
		//console.log(this.openedSubmenus)

		//ošetření připomínky: pokud otevřené submenu zavřu otevřením jiného, tak se mi šipka toho zavřeného už nevrátí zpátky do původního stavu (směrem dolů), ale zůstane nahoře.
		if (this.menu.filter((f) => f.id !== item.id).length > 0) {
			(this.menu.filter((f) => f.id !== item.id)).forEach(function (currentItem) {
				$("#mm-main-item-link_" + currentItem.id + " .menu-child-icon").removeClass("fa-chevron-up");
				$("#mm-main-item-link_" + currentItem.id + " .menu-child-icon").addClass("fa-chevron-down");
			});
		}

		if (item.label.indexOf("fa-chevron-down") > 0) {
			item.label = item.label.replace("fa-chevron-down", "fa-chevron-up");
		}
		else {
			item.label = item.label.replace("fa-chevron-up", "fa-chevron-down");
		}

		if (this.menu.filter((f) => f.parentId === item.id).length > 0) {
			if (this.openedSubmenus.find(f => f === item.id)) {
				this.openedSubmenus = this.openedSubmenus.filter(f => f != item.id);
			}
			else {
				this.openedSubmenus = [];
				this.openedSubmenus.push(item.id);
			}
		}
	}
}

export default WmsMenu;
